module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306230.2ab26345.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_306230.pdf
// module id = 338
// module chunks = 0